import { ImportDataLegalEntitiesQuery } from '@/__generated__/graphql';
import Button from '@/components/basicComponents/button';
import Select from '@/components/basicComponents/select';
import { createSimpleSelectOption } from '@/components/basicComponents/select/utils';
import { IEntityCodesTableData } from '@/components/settings-page/importData/types';
import {
  MobileRow,
  MobileRowTitle,
  MobileRowValue,
  MobileTableRowWrap,
  MobileTableWrapper,
  NoResults
} from '@/components/table/mobileTable/mobileTable';
import styled from 'styled-components';
import { columns } from '../constants';
import { RowStatus } from './cell/rowStatus';

interface MobileTableProps {
  tableData: IEntityCodesTableData[];
  sortedLegalEntities: ImportDataLegalEntitiesQuery['LegalEntities'];
  legalEntitiesLoading: boolean;
  handleChangeAssignment: (entityId: string, prevValue: string, entityCode: string) => void;
  resetAssignment: (entityCode: string, prevValue: string) => void;
}

const MobileTable = ({ tableData, sortedLegalEntities, legalEntitiesLoading, handleChangeAssignment, resetAssignment }: MobileTableProps) => {
  const TableRow = ({ el }: { el: IEntityCodesTableData }) => {
    return (
      <MobileTableRowWrap key={el.id}>
        <MobileRow>
          <MobileRowTitle>{columns[0].title}</MobileRowTitle>
          <MobileRowValue>{el.entityCode}</MobileRowValue>
        </MobileRow>

        <MobileRow>
          <MobileRowTitle>{columns[1].title}</MobileRowTitle>
          <MobileRowValue>{el.entityName}</MobileRowValue>
        </MobileRow>

        <MobileRow>
          <MobileRowTitle>{columns[2].title}</MobileRowTitle>
          <MobileRowValue>
            {el.entityStatus === 'Assigned' ? (
              <>{el.entityAssignment}</>
            ) : (
              <Select
                value={el.entityAssignment}
                previewValue={el.entityAssignment === 'Select An Entity' ? '' : el.entityAssignment}
                setValue={(value) => handleChangeAssignment(value, el.entityAssignment, el.entityCode)}
                options={sortedLegalEntities.map((entity) => createSimpleSelectOption(`${entity.entityName} (${entity.tenant.name})`))}
                loading={legalEntitiesLoading}
                size="md"
                additionalOption={
                  <ClearSelectionButtonWrapper>
                    <Button
                      size="sm"
                      onClick={() => resetAssignment(el.entityCode, el.entityAssignment)}
                      styleType={el.entityAssignment === 'Select An Entity' ? 'disabled' : 'outline'}
                    >
                      Clear Selection
                    </Button>
                  </ClearSelectionButtonWrapper>
                }
                withSearch
              />
            )}
          </MobileRowValue>
        </MobileRow>

        <MobileRow>
          <MobileRowTitle>{columns[3].title}</MobileRowTitle>
          <MobileRowValue>
            <RowStatus status={el.entityStatus} />
          </MobileRowValue>
        </MobileRow>
      </MobileTableRowWrap>
    );
  };

  return (
    <MobileTableWrapper>
      {tableData.length ? (
        tableData.map((el: IEntityCodesTableData, index: number) => {
          return <TableRow el={el} key={index} />;
        })
      ) : (
        <NoResults>No Results</NoResults>
      )}
    </MobileTableWrapper>
  );
};

export default MobileTable;

const ClearSelectionButtonWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
`;
